<script setup lang="ts">
import { ref, onMounted, watch, computed, nextTick } from "vue";
import AsyncImage from "../../../../../components/ui/form/AsyncImage.vue";
//import { usePosStore } from "../../../../../stores/product";
import { Item, ItemCategory, ItemGroup, ItemPackingPrice, PaymentType, PosStation } from "../../../../../types/models";
import { tokenManager } from "../../../../../api/utils/tokenManager";
import {posStore } from '../../../../../stores/posStore'
import MessageBox from "../../../../../services/MessageBox";
import IconComponent from "../../../../../components/ui/common/IconComponent.vue";
import { User } from "../../../../../types/auth";
import { api } from "../../../../../api/Api";
import Toast from "../../../../../services/Toast";
import ItemPricesForm from '../../../../inventory/itemmanagement/itemprices/ItemPricesForm.vue'
import { formatNumber } from "../../../../../utils/CommonFunctions";
import { useScreenSize } from "../../../../../utils/useScreenSize";

const { isMobile, isTablet } = useScreenSize();

const props = defineProps<{
  isFullscreen: boolean;
  payment_types: PaymentType[]
  item_categories: ItemCategory[]
  item_groups: ItemGroup[]
  delivery_staffs: User[]
  posStation: PosStation | undefined
}>();

defineEmits<{
  (e: 'addItem', item: Item): void
  (e: 'close'): void
}>()

//const store = usePosStore();
const pos = posStore();
const searchQuery = ref("");
const selectedCategory = ref<ItemCategory | null>(null);
const searchInput = ref<HTMLInputElement | null>(null);
const filteredProducts = ref<Item[]>([]);


defineExpose({
  focusSearch() {
    searchQuery.value = "";
    searchInput.value?.focus();
  },
});


const getProducts = () => {
  pos
    .searchProducts(searchQuery.value, currentPage.value, itemsPerPage)
    .then((result) => {
      filteredProducts.value = result;
      if (filteredProducts.value.length === 1) {
        let prod = filteredProducts.value[0];
        if (prod.code?.toLowerCase() == searchQuery.value.toLowerCase() || prod.barcodes?.find(b => b.code.toLowerCase() == searchQuery.value.toLowerCase())) {
          handleProductClick(prod);
        } else if (prod.packing_prices && prod.packing_prices.find(p => p.code?.toLowerCase() == searchQuery.value.toLowerCase())) {
          const packing = prod.packing_prices.find(p => p.code?.toLowerCase() == searchQuery.value.toLowerCase());
          if (packing) {
            handlePackingClick(packing, prod);
          }
        }
      } else if (filteredProducts.value.length > 1) {
        // Check if the search query matches any product code or barcode
        const matchingProduct = filteredProducts.value.find((product) => {
          return (
            product.code?.toLowerCase() === searchQuery.value.toLowerCase() ||
            product.barcodes?.some(
              (barcode) => barcode.code.toLowerCase() === searchQuery.value.toLowerCase()
            )
          );
        });

        if (matchingProduct) {
          handleProductClick(matchingProduct);
        }
      } else {
        handleRemoteSearch();
      }
    })
    .catch((error) => {
      filteredProducts.value = [];
      console.log("Error fetching products:", error);
    });
};

const handleRemoteSearch = async () => {
  if (searchQuery.value.length > 0) {
    const params = {
    search_query: searchQuery.value,
    price_lists_id: pos.selectedPosInvoice?.invoice?.customer && pos.selectedPosInvoice?.invoice?.customer.price_lists_id ? pos.selectedPosInvoice?.invoice?.customer.price_lists_id : props.posStation?.outlet?.price_lists_id,
    warehouses_id: props.posStation?.outlet?.warehouses_id,
    };
    const response = await api.post(
      "inventory/item-management/items/search",
      params
    );
    if (response.success == true) {
      filteredProducts.value = response.data;
      filteredProducts.value.forEach((el) => {
        if (el.variant_packing_prices && el.variant_packing_prices.length > 0) {
          el.packing_prices = el.variant_packing_prices;
        }
      });
      if (response.data.length == 1 && (!response.data[0].packing_prices || response.data[0].packing_prices.length == 0)
      && (!response.data[0].variant_packing_prices || response.data[0].variant_packing_prices.length == 0)) {
        handleProductClick(response.data[0]);
      } else if (response.data.length > 1) {
        //selectItems.value = response.data;
        //showItemsDialog.value = true;
      } else if (!response.data || response.data.length <= 0) {
        Toast.show("Item not found", "warning");
      }
    } else {
      Toast.show("Item not found", "warning");
    }
  }
};

const selectCategory = async (category: ItemCategory) => {
  selectedCategory.value =
    selectedCategory.value === category ? null : category;
    const params = {
    category: selectedCategory.value?.id,
    price_lists_id: pos.selectedPosInvoice?.invoice?.customer && pos.selectedPosInvoice?.invoice?.customer.price_lists_id ? pos.selectedPosInvoice?.invoice?.customer.price_lists_id : props.posStation?.outlet?.price_lists_id,
    warehouses_id: props.posStation?.outlet?.warehouses_id,
    };
    const response = await api.post(
      "inventory/item-management/items/search",
      params
    );
    if (response.success == true) {
      filteredProducts.value = response.data;
    } else {
      Toast.show("Item not found", "warning");
    }
};




const currentPage = ref(1);
const itemsPerPage = 30;
const handlePageChange = (page: number) => {
  currentPage.value += page;
  getProducts();
};

const handleProductClick = (product: Item) => {
  pos.addProductToInvoice(product)
  if (!isMobile && !isTablet) {
    nextTick(() => {
      focusSearch();
    })
  }
};

const showItemDetailForm = ref(false);
const selectedProduct = ref<Item | null>(null);
const displayProductInfo = (product: Item) => {
  selectedProduct.value = product;
  showItemDetailForm.value = true;
  //showProductInfo.value = true;
  //selectedProduct.value = product;
};

const handlePackingClick = (packing: ItemPackingPrice, product: Item) => {
  let prod: Item = {
    item_name: product.name + " " + packing.unit_of_measure + (packing.inventory_qty > 1 ? 'x' + packing.inventory_qty : ''),
    id: product.id,
    photo: product.photo, //TODO: seperate photo for packing prices  
    code: packing.code,
    name: product.name + " " + packing.unit_of_measure + (packing.inventory_qty > 1 ? 'x' + packing.inventory_qty : ''),
    item: product.name + " " + packing.unit_of_measure + (packing.inventory_qty > 1 ? 'x' + packing.inventory_qty : ''),
    item_type: product.item_type,
    sales_name: product.name + " " + packing.unit_of_measure + (packing.inventory_qty > 1 ? 'x' + packing.inventory_qty : ''),
    item_types_id: product.item_types_id,
    tracked_by: product.tracked_by,
    sales_uom: packing.unit_of_measure,
    sales_uom_qty: packing.inventory_qty,
    is_package: product.is_package,
    use_package_price: product.use_package_price,
    flexi_price: product.flexi_price,
    ignore_discount: product.ignore_discount,
    is_expiry: product.is_expiry,
    tax_details_id: product.tax_details_id,
    inventory_uom_id: product.inventory_uom_id,
    inventory_uom_qty: product.inventory_uom_qty,
    sales_uom_id: packing.unit_of_measures_id,
    has_variants: product.has_variants,
    variants: product.variants,
    tax: product.tax,
    tax_rate: product.tax_rate,
    uid: product.uid,
    warehouses_id: props.posStation?.outlet?.warehouses_id,
    price_lists_id: props.posStation?.outlet?.price_lists_id,
    items_id: product.id,
    item_variants_id: product.item_variants_id,
    unit_of_measures_id: packing.unit_of_measures_id,
    unit_of_measure: packing.unit_of_measure,
    on_hand: product.on_hand,
    quantity: 1,
    uom_qty: packing.inventory_qty,
    inventory_qty: 1 * packing.inventory_qty,
    cost: product.cost,
    original_price: packing.selling_price,
    selling_price: packing.selling_price,
    price: packing.selling_price,
    sub_total: packing.selling_price,
    discount_p: 0,
    discount_a: 0,
    value_before_tax: product.selling_price,
    tax_amount: 0,
    net_total: 0,
    remarks: '',
    batches: [],
    serials: [],
    quantity_prices: [],
    packing_prices: [],
    barcodes: [],
    shelfs: [],
    variant_list: [],
    variant_name: product.variant_name,
    showPackingPrices: product.showPackingPrices,
    isFocused: false,
    isHovered: false,
    isExpanded: false,
    default_sales_uom_id: packing.unit_of_measures_id,
    default_sales_uom_qty: packing.inventory_qty
  }
  pos.addProductToInvoice(prod)
  nextTick(() => {
    focusSearch();
  })
};

const focusSearch = () => {
  searchQuery.value = "";
  searchInput.value?.focus();
};

const handleVoid = () => {
  MessageBox.confirm({
      title: "VOID BILL",
      message:
        "Are you sure you want to void this bill? All items will be removed from the cart.",
      confirmText: "VOID BILL",
      cancelText: "KEEP BILL",
    }).then((confirmed: any) => {
      if (confirmed) {
        pos.voidInvoice()
      }
    });
};

const currencyCode = computed(() => {
  return props.posStation?.outlet?.currency_code ?? "";
});
const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode.value,
  }).format(amount);
};

const posStation = ref<PosStation>()

const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === "F2") {
      event.preventDefault();
      focusSearch();
    } else if (event.key === "F9" && (pos.selectedPosInvoice?.invoice.customer || (pos.selectedPosInvoice?.invoice.items && pos.selectedPosInvoice.invoice.items.length > 0))) {
      event.preventDefault();
      handleVoid();
    } 
  };

// Register keyboard shortcuts
onMounted(() => {
  let station = tokenManager.getPosStation();
  if (station) {
    posStation.value = station;
  }
  //getProducts();


  window.addEventListener("keydown", handleKeyPress);

  /*if (props.item_categories.length > 0) {
    selectCategory(props.item_categories[0]);
  } */
  
});

/*watch(() => pos.selectedPosInvoice?.invoice?.customer, () => {
  if (pos.selectedPosInvoice?.invoice?.customer && pos.selectedPosInvoice?.invoice?.customer.price_lists_id && 
      pos.selectedPosInvoice?.invoice?.customer.price_lists_id != props.posStation?.outlet?.price_lists_id) {
    if (props.item_categories.length > 0) {
    selectCategory(props.item_categories[0]);
  }
  } 
});*/

watch(() => pos.showCheckoutModal, () => {
  if (pos.showCheckoutModal) {
    window.removeEventListener("keydown", handleKeyPress);
  } else {
    window.addEventListener("keydown", handleKeyPress);
  }
});

</script>

<template>
  <div
    class="h-full bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 flex flex-col"
  >
    <!-- Search Box -->
    <div class="p-4 border-b border-gray-200 dark:border-gray-700">
      <div class="flex items-center gap-2">
        <div class="relative flex-1">
          <IconComponent name="Search" class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />
          <input
            ref="searchInput"
            v-model="searchQuery"
            type="search"
            placeholder="Search products... (F2)"
            @keyup.enter="getProducts"
            class="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900"
          />
        </div>

        <!-- Void Button -->
        <button
          v-if="pos.selectedPosInvoice?.invoice.customer || (pos.selectedPosInvoice?.invoice.items && pos.selectedPosInvoice.invoice.items.length > 0)"
          @click="handleVoid"
          class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center gap-2"
        >
          <IconComponent name="Trash2" class="w-5 h-5" />
          Void (F9)
        </button>
      </div>
    </div>

    <!-- Categories List -->
    <div class="border-b border-gray-200 dark:border-gray-700 overflow-x-auto">
      <div class="p-4 flex gap-2">
        <button
          v-for="category in item_categories"
          :key="category.id"
          @click="selectCategory(category)"
          class="px-4 py-2 rounded-lg text-left transition-colors flex items-center gap-2 whitespace-nowrap"
          :class="[
            selectedCategory?.id === category.id
              ? 'bg-blue-50 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400'
              : 'hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300',
          ]"
        >
          <span
            v-if="category.icon && category.icon.trim().startsWith('<svg')"
            v-html="category.icon"
            class="w-6 h-6 flex items-center justify-center [&_svg]:w-full [&_svg]:h-full"
          />
          <span v-else-if="category.icon" class="text-xl">{{ category.icon }}</span>
          <span class="text-sm">{{ category.name }}</span>
        </button>
      </div>
    </div>

    <!-- Products Grid -->
    <div class="flex-1 p-4 overflow-y-auto">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4"
      >
        <template v-for="product in filteredProducts" :key="product.id">
          <div
            @click="handleProductClick(product)"
            class="w-full max-w-[150px] p-4 rounded-lg transition-colors 
            text-center group cursor-pointer relative"
            :class="{'bg-gray-50 dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800': Number(product.on_hand) > 0, 
            'bg-red-200 dark:bg-red-700': Number(product.on_hand) <= 0}"
          >
          <div class="absolute top-2 right-2">
            <button
              @click.stop="displayProductInfo(product)"
              class="p-0 transition-colors"
            >
                <IconComponent 
                name="MoreVertical" 
                class="w-5 h-5 text-gray-600 dark:text-gray-300 group-hover:text-blue-600 dark:group-hover:text-blue-400" 
                />
            </button>
          </div>
            <div
              class="w-16 h-16 mx-auto mb-2 text-3xl flex items-center justify-center"
            >
              <AsyncImage :src="product.photo" :alt="product.name" :readonly="true" class-name="max-h-[80px]" />
            </div>
            <h2 class="font-medium text-gray-900 dark:text-white text-sm mb-1">
              {{ product.code }}
            </h2>
            <h3 class="font-medium text-gray-900 dark:text-white text-sm mb-1">
              {{ (product.name ?? '').length > 50 ? (product.name ?? '').substring(0, 50) + '...' : (product.name ?? '') }}
               <br /> {{ product.sales_uom }} <span v-if="(product.sales_uom_qty ?? 0)> 1">x {{ product.sales_uom_qty }} {{ product.unit_of_measure }}</span>
            </h3>
            <p class="text-sm text-gray-600 dark:text-gray-400">
              {{ formatCurrency(product.price) }}
            </p>
            <div class="flex items-center justify-center text-sm text-gray-600 dark:text-gray-400">
              <IconComponent name="Boxes" />
              <span class="ml-1">{{ formatNumber((product.on_hand ?? 0) / (product.sales_uom_qty ?? 1)) }}</span>
            </div>
          </div>
          <template v-if="product.packing_prices && product.packing_prices.length > 0">
            <div class="w-full max-w-[150px] p-4 rounded-lg transition-colors 
            text-center group cursor-pointer relative"
            :class="{'bg-gray-50 dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800': Number(product.on_hand) > 0, 
            'bg-red-200 dark:bg-red-700': Number(product.on_hand) <= 0}">
            <button
              v-for="packing in product.packing_prices.filter(p => p.price_lists_id  == posStation?.outlet?.price_lists_id)"
              :key="packing.code"
              @click="handlePackingClick(packing, product)"
              class="w-full max-w-[150px] rounded-lg bg-gray-50 dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-center group"
              :class="{'bg-gray-50 dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800': Number(product.on_hand) > 0, 
            'bg-red-200 dark:bg-red-700 hover:bg-red-200 dark:hover:bg-red-700': Number(product.on_hand) <= 0}"
            >
            <div class="absolute top-2 right-2">
            <button
              @click.stop="displayProductInfo(product)"
              class="p-0 transition-colors"
            >
                <IconComponent 
                name="MoreVertical" 
                class="w-5 h-5 text-gray-600 dark:text-gray-300 group-hover:text-blue-600 dark:group-hover:text-blue-400" 
                />
            </button>
          </div>
              <div
                class="w-16 h-16 mx-auto mb-2 text-3xl flex items-center justify-center"
              >
                <AsyncImage :src="product.photo" :alt="product.name" :readonly="true" class-name="max-h-[80px]" />
              </div>
              <h2 class="font-medium text-gray-900 dark:text-white text-sm mb-1">
                {{ packing.code }}
              </h2>
              <h3 class="font-medium text-gray-900 dark:text-white text-sm mb-1">
                {{ product.name }} <br /> {{ packing.unit_of_measure }} <span v-if="(packing.inventory_qty ?? 0)> 1">x {{ packing.inventory_qty }} {{ product.unit_of_measure }}</span>
              </h3>
              <p class="text-sm text-gray-600 dark:text-gray-400">
                {{ formatCurrency(packing.selling_price) }}
              </p>
              <div class="flex items-center justify-center text-sm text-gray-600 dark:text-gray-400">
              <IconComponent name="Boxes" />
              <span class="ml-1">{{ formatNumber((product.on_hand ?? 0) / (packing.inventory_qty ?? 1)) }}</span>
            </div>
            </button>
          </div>
          </template>
        </template>
      </div>

      <!-- Pagination -->
      <div class="flex justify-center items-center mt-6 space-x-2" v-if="pos.totalPages > 1">
        <button
          @click="handlePageChange(-1)"
          :disabled="currentPage === 1"
          class="px-3 py-1 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50"
        >
          Previous
        </button>

        <div class="flex space-x-1">
          <button
            v-for="page in pos.totalPages"
            :key="page"
            @click="handlePageChange(page)"
            class="px-3 py-1 text-sm font-medium rounded"
            :class="[
              currentPage === page
                ? 'bg-blue-600 text-white'
                : 'text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700',
            ]"
          >
            {{ page }}
          </button>
        </div>

        <button
          @click="handlePageChange(1)"
          :disabled="currentPage === pos.totalPages"
          class="px-3 py-1 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  </div>
  <ItemPricesForm v-if="showItemDetailForm" :data="selectedProduct" mode="view" end-point="inventory/item-management/items"
    @close="showItemDetailForm = false" :ignore-permission="true" :show-inventory="true" title="Item Details" :price_lists_id="posStation?.outlet?.price_lists_id" />
</template>
